export const QUESTION_TYPES = {
  // Maps to Attitude Factor
  // Purpose: Initial engagement and personality assessment
  warmup: {
    label: 'Warm-up',
    bg: 'bg-[#fff0eb]',
    text: 'text-[#ff4500]',
    hover: 'hover:bg-[#ffe4db]',
  },

  // Maps to Career Progression Factor
  // Purpose: Understanding professional journey and growth
  background: {
    label: 'Background',
    bg: 'bg-[#e6fafa]',
    text: 'text-[#00a9ac]',
    hover: 'hover:bg-[#d6f5f5]',
  },

  // Maps to Skills and Qualifications Factor
  // Purpose: Direct assessment of technical capabilities
  technical: {
    label: 'Technical',
    bg: 'bg-[#ffebf3]',
    text: 'text-[#ee1065]',
    hover: 'hover:bg-[#ffe0ec]',
  },

  // Maps to Professional Experience Factor
  // Purpose: Evidence of past performance and expertise
  behavioral: {
    label: 'Behavioral',
    bg: 'bg-[#fff5e6]',
    text: 'text-[#faa00c]',
    hover: 'hover:bg-[#ffefcc]',
  },

  // Maps to Achievements and Accomplishments Factor
  // Purpose: Problem-solving and success scenarios
  situational: {
    label: 'Situational',
    bg: 'bg-[#f3e6f5]',
    text: 'text-[#87328f]',
    hover: 'hover:bg-[#ebd6ee]',
  },

  // Maps to Cultural Fit Factor
  // Purpose: Values alignment and team dynamics
  cultural: {
    label: 'Cultural',
    bg: 'bg-[#f2fae6]',
    text: 'text-[#84bd00]',
    hover: 'hover:bg-[#e9f7cc]',
  },

  // Maps to Educational Background Factor
  // Purpose: Knowledge foundation and learning approach
  closing: {
    label: 'Closing',
    bg: 'bg-[#e6f6fe]',
    text: 'text-[#27aae1]',
    hover: 'hover:bg-[#d6f0fc]',
  }
};

export const getTypeStyles = (type) => {
  const styles = QUESTION_TYPES[type] || QUESTION_TYPES.behavioral;
  return `${styles.bg} ${styles.text}`;
};

export const getTypeLabel = (type) => {
  return QUESTION_TYPES[type]?.label || type;
}; 